<template>

                    <tbody>
                    <tr>
                        <td class="pl-0">
                            <div class="d-flex align-items-center">
                                <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                    <div v-if="variant.images && variant.images.length > 0" class="symbol-label" :style="{ backgroundImage: 'url(' + $urlBackEnd(variant.images[0].thumbnail) + ')' }"></div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                {{variant.sku}}
                            </span>
                        </td>
                        <td>
                            <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                {{numberWithSpaces(variant.price)}} р
                            </span>
                        </td>
                        <td v-if="product.type === 'in_stock'">
                            <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                {{variant.stock}}
                            </span>
                        </td>
                        <td>
                            <template v-for="(attribute, i) in variant.attributes">
                                <span v-if="attribute.value" v-bind:key="i"  class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                    {{attribute.name}}: <span class="text-muted font-weight-bold">{{attribute.value.name}}</span>
                                </span>
                            </template>

                        </td>
                        <td class="text-right pr-0">
                            <b-button @click="editVariantItem" size="sm" class="mr-2" variant="primary">Редактировать</b-button>
                            <b-button @click="deleteVariantItem" size="sm" variant="danger">Удалить</b-button>
                        </td>
                    </tr>
                    </tbody>

</template>

<script>
    export default {
        name: "VariationsProductItem",
        props: [ 'variant', 'product'],

        methods:{

            editVariantItem(){
                this.$emit('edit_variant', this.variant);
            },

            deleteVariantItem(){
                this.$emit('delete_variant', this.variant.id);
            },

            numberWithSpaces(x){
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            },

        }

    }
</script>

<style scoped>

</style>